<div class='flex-row'>
  @if (!undone()) {
    <span>{{ message() }}</span>
    <div class='flex'></div>
    <button mat-button
            (click)='undoCreate()'
            data-testid='undo-button'
            class='undo'>
      {{ 'undo-snackbar.undo' | translate }}
    </button>
  } @else if (undone()) {
    <span>{{ 'undo-snackbar.undone' | translate }}</span>
    <div class='flex'></div>
  }

  @if (!undone()) {
    <button mat-icon-button
            attr.aria-label='{{ "common.close" | translate }}'
            data-testid='close-button'
            (click)='close()'>
      <mat-icon svgIcon='close'></mat-icon>
    </button>
  }
</div>
